/**
 * Central API configuration helper.
 * Strips trailing slashes to guarantee clean endpoint concatenation.
 */
export function getApiBaseUrl() {
  const url = process.env.REACT_APP_RIVYOO_API_BASE_URL || "https://api.rivyou.co";
  return url.endsWith("/") ? url.slice(0, -1) : url;
}
